import React from 'react';
import SvgIcon from 'material-ui/SvgIcon';

let IconClub = (props) => {
  props = Object.assign({viewBox: '0 0 30 30'}, props);
  return (
    <SvgIcon {...props}>
      <path class="st0" d="M28.8,28.8h-7.5l0-20.1h-2.5l0,20.1h-7.5l0-20.1H8.7l0,20.1H1.2l0-27.6l27.6,0L28.8,28.8z M22.5,27.6h5.1
	      l0-25.2H2.4l0,25.2h5.1l0-20.1h4.9l0,20.1h5.1l0-20.1h4.9L22.5,27.6z"/>
    </SvgIcon>
  );
};

IconClub.displayName = 'IconClub';
IconClub.muiName = 'SvgIcon';

export default IconClub;



// WEBPACK FOOTER //
// ./src/components/Icons/IconStudios.js